module.exports = __webpack_public_path__ + "/images/ico-primary-eurosend.156beed.svg";